<template>
      <v-container>
        <v-row no-gutters justify="center">
          <v-col cols="10">
            <CreateDotsForm :data="data" @emitData="submitData" />
          </v-col>
        </v-row>
      </v-container>
  </template>
  
  <script>
  import CreateDotsForm from "./components/CreateDotsForm.vue";
  
  export default {
    components: {
      CreateDotsForm,
    },
    created() {
    },
    computed: {
    },
    methods: {
      submitData(data) {
        this.$store.dispatch('DotsPatient/save',data).then(() => {
          this.$router.push('/dots')
        })
      }
    },
  };
  </script>
  
  <style></style>
  